import React, { Component } from 'react';
import { Modal, ModalBody } from "reactstrap";
import './new-homework.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Filter from './filter/filter'
import DropdownV5 from '../../common/dropdown-v5/dropdown';
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../common/dropdown-v4/dropdown';

import ConceptDetail from './concept-detail/concept-detail'
// import ConceptDetail from './question-detail/question-detail'
import Report from '../completion-report/completion-report'
import HomeworkApi from '../../../apis/homework'
import SchoolUserApi from '../../../apis/student'
import QuestionList from '../new-homework/questions-list/questions-list';
import Loading from '../../common/loading/loading'
import CommonUtils from '../../../utility/common-utilities';
import EloDetail from '../homework-list/elo-detail/elo-detail'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';


class NewHomeWork extends Component {

    state = {
        isAdaptive: this.props.type == "ADAPTIVE",
        numberOfQuestions: 0,
        approximateTime: 0,
        studentList: [],
        eloDropdownItems: [],
        homeworkDropdownItems: [],
        selectedHomeworkId: '',
        selectedIndex: '',
        selectedHomeworkMore: '',
        selectedHomeworkBasedStudentGrouping: false,
        categories: [
            {
                type: "NOVICE",
                title: "NOVICE",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "PROFICIENT",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "ADVANCED",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        criterionDropdownItems: [{ title: "Start from level 1", value: 1 }, { title: "Start from level 2", value: 2 }, { title: "Start from level 3", value: 3 }]
    }

    componentDidMount() {
    }

    onClickCreate() {

        if (this.state.isAdaptive) {
            this.onCreateAdaptive()
            return
        }
        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: this.props.type
        }
        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0
        let validate = this.validatePayload(payload)
        if (!validate) {
            this.setState({ isCreate: true })
            return
        }
        this.saving = true
        this.setState({ isLoading: true })

        if (this.props.type === 'ADAPTIVE') {

            let criteriaHash = {}
            payload.concepts = [payload.concepts]

            for (let i = 0; i < this.state.categories.length; i++) {
                criteriaHash[this.state.categories[i].type] = { level: this.state.categories[i].selectedCriterion }

            }
            payload.criterion = criteriaHash
        }

        HomeworkApi.createHomework(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false })

            let homework = { ...response.data, ...payload, created: true }
            if (!homework.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(homework, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(homework)
            }
            homework.point = 10
            if (homework.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(homework)
            }
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework(true)
        }).catch(err => {
            this.saving = false
            this.setState({ isLoading: false })
        })
    }

    onCreateAdaptive() {
        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: this.props.type,
            categories: this.state.categories
        }
        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0
        let validate = this.validatePayload(payload)
        if (!validate) {
            this.setState({ isCreate: true })
            return
        }
        this.saving = true
        this.setState({ isLoading: true })

        HomeworkApi.createAdaptiveHomework(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false })

            let homework = { ...response.data, ...payload, created: true }
            if (!homework.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(homework, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(homework)
            }
            homework.point = 10
            if (homework.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(homework)
            }
            this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework(true)
        }).catch(err => {
            this.saving = false
            this.setState({ isLoading: false })
        })
    }

    validatePayload = (payload) => {
        if (!payload.board) {
            this.setState({ selectBoardMessage: true })
            return false
        }

        if (!payload.class) {
            this.setState({ selectClassMessage: true })
            return false
        }

        // if (!payload.section) {
        //     this.setState({ selectSectionMessage: true })
        //     return false
        // }

        if (!payload.chapter) {
            this.setState({ selectChapterMessage: true })
            return false
        }

        if (!payload.concepts || payload.concepts.length == 0) {
            this.setState({ selectConceptMessage: true })
            return false
        }

        if (payload.type === 'ADAPTIVE') {

            for (let i = 0; i < payload.categories.length; i++) {
                let item = payload.categories[i]
                if (!item?.selectedElo || !item?.selectedElo?.length) {
                    this.setState({ selectEloMessage: true })
                    return false
                }
            }

        }

        if (!payload.dueDate) {
            this.setState({ selectDueDateMessage: true })
            return false
        }

        return true

    }

    onClickBack = () => {
        this.props?.delegate?.hideNewHomework && this.props.delegate.hideNewHomework()
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    onClickQuestionList = (categories, index) => {

        //console.log("Categories", categories)

        if (categories) {
            let selectedCategoryElos = categories[index].selectedElo

            this.getEloDetails(selectedCategoryElos, index)

            this.setState({ showQuestionList: true, categories, selectedIndex: index })
        } else {
            this.setState({ showQuestionList: true })
        }


    }

    hideQuestionList = () => {
        this.setState({ showQuestionList: false })
    }

    onClickMenu = () => {
        this.setState({ showReport: true })
    }

    onDragStart = (event, dragInfo) => {

        event.target.style.cursor = 'cursor';
        event.stopPropagation();
        this.dragStartInfo = dragInfo;
        this.setState({ dragStartIndex: dragInfo.index })
    };

    onDragEnd = (event) => {
        event.target.style.cursor = 'cursor';
        this.setState({ dragStartIndex: null })
        let categories = this.state.categories
        if (this.dragOverInfo.type === this.dragStartInfo?.category?.type) return

        let dragFrom, dragTo

        for (let i = 0; i < categories.length; i++) {
            if (categories[i].type == this.dragStartInfo?.category?.type) {
                dragFrom = {
                    category: categories[i],
                    index: i
                }
            }
            if (categories[i].type == this.dragOverInfo?.type) {
                dragTo = {
                    category: categories[i],
                    index: i
                }
            }
            if (dragFrom && dragTo) break
        }

        if (dragFrom && dragTo) {
            let dragFromStudents = dragFrom.category.students
            dragFromStudents.splice(this.dragStartInfo?.index, 1)
            dragFrom.students = dragFromStudents

            if (dragTo.category.students) {
                dragTo.category.students.unshift(this.dragStartInfo.student)
            }

            categories[dragFrom.index] = dragFrom.category
            categories[dragTo.index] = dragTo.category
            this.setState({ categories, dragStartIndex: null })
        }

    }

    onDragOver = (event, cardInfo) => {
        event.preventDefault(); //allow drop here
        this.dragOverInfo = cardInfo
    }

    showConceptDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideInfoModal} size={'lg'}>
                <ModalBody >
                    <ConceptDetail back={this.hideInfoModal} payload={this.state.payload} delegate={this} conceptsInfo={this.state.conceptsInfo} chapterTitle={this.state.selectedChapterTitle} chapterKey={this.state.selectedChapterKey} conceptTitles={this.state.selectedConceptsName} />
                </ModalBody>
            </Modal>
        )

    }

    showQuestionList = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionList back={this.hideQuestionList} contents={this.state.contents}
                        questionCount={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].questionCount : (this.state.questionCount || 0)}
                        approximateTime={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].approximateTime : (this.state.approximateTime || 0)} />
                </ModalBody>
            </Modal>
        )
    }

    onSelectElo = (options, index, selectedFilter) => {

        //console.log(options, index, selectedFilter)

        let groupByConcept = {}
        let conceptList = []

        let groupBySkill = {}


        for (let i = 0; i < options.length; i++) {
            let option = options[i]

            if (!groupByConcept[option?.conceptValue])
                groupByConcept[option.conceptValue] = { key: option.conceptValue, elos: [{ id: option?.value }] }
            else
                groupByConcept[option.conceptValue].elos.push({
                    id: option?.value
                })

            if (!groupBySkill[option?.skill]) {
                groupBySkill[option.skill] = { key: option.skill, elos: [option?.value] }
            } else {

                if (groupBySkill[option.skill].elos.includes(option?.value)) {
                    let index = groupBySkill[option.skill].elos.findIndex(ele => ele === option?.value)
                    groupBySkill[option.skill].elos.splice(index, 1)
                }
                else {
                    groupBySkill[option.skill].elos.push(option?.value)
                }
            }
        }

        let skillWiseSelectedOptionsCountHash = {}

        let skillsArray = Object.keys(groupBySkill)

        skillsArray.forEach(skill => {

            skillWiseSelectedOptionsCountHash[skill] = groupBySkill[skill].elos.length
        })





        let conceptKeys = []

        for (let i = 0; i < this.state.conceptsArray.length; i++) {

            conceptKeys.push(this.state.conceptsArray[i].key)

        }

        for (let i = 0; i < conceptKeys.length; i++) {

            let key = conceptKeys[i]
            if (groupByConcept[key]) {
                conceptList.push({
                    key,
                    elos: groupByConcept[key].elos
                })
            }
        }

        let values = options.map(option => option?.value)




        let categories = this.state.categories
        categories[index].selectedElo = values
        categories[index].conceptList = conceptList
        categories[index].selectedFilter = selectedFilter
        categories[index].skillWiseSelectedOptionsCountHash = skillWiseSelectedOptionsCountHash

        this.setState({ categories })
        this.getEloDetails(values, index)
    }


    onSelectDropDown(option, cardInfo, index) {

        let selectedElos = cardInfo.selectedElos || []

        if (selectedElos.includes(option?.value)) {
            selectedElos = selectedElos.filter(item => item !== option?.value)
        } else {
            selectedElos.push(option?.value)
        }

        cardInfo.selectedElos = selectedElos
        let categories = this.state.categories
        categories[index] = cardInfo
        this.setState({ categories })
    }



    handleFilter = (payload, refreshStudent) => {
        console.log(payload)
        this.setState({ payload }, () => {
            refreshStudent && this.getStudents()
            this.getChapterHierarchy()
            this.getStandardHomeworkList()

            if (this.props.type === 'ADAPTIVE' && payload.concepts) {

                let levelArray = []
                let categories = this.state.categories

                for (let i = 0; i < payload.concepts.length; i++) {

                    let concept = this.state.conceptsHash[payload.concepts[i]]
                    for (let i = 0; i < concept.elos.length; i++) {
                        levelArray.push({ title: `Start from level ${i + 1}`, value: i + 1 })

                    }
                    if (concept.elos.length === 1) {

                        for (let i = 0; i < categories.length; i++) {
                            categories[i].selectedCriterion = 1
                        }

                    } else if (concept.elos.length === 2) {

                        for (let i = 0; i < categories.length; i++) {
                            if (categories[i].type === "NOVICE") {
                                categories[i].selectedCriterion = 1
                            } else {
                                categories[i].selectedCriterion = 2
                            }

                        }

                    } else {
                        for (let i = 0; i < categories.length; i++) {
                            categories[i].selectedCriterion = i + 1
                        }
                    }
                }

                this.setState({ criterionDropdownItems: levelArray, reloadDropdown: true, categories }, () => {
                    this.setState({ reloadDropdown: false })
                })

            }
        })

    }

    getChapterHierarchy(payload = {}) {

        if (!this.state.payload || !this.state.payload.chapter) {
            return
        }

        if (this.state.payload.chapter) {
            this.getEloDetails()
        }


        payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            selectedChapter: this.state.payload?.chapter,
            // status: "ONBOARDED"
        }


        HomeworkApi.getChapterHierarchy(payload)
            .then(response => {

                //console.log("response", response)

                let conceptsName = []

                this.storeConceptDetails(response.chapter)

                for (let i = 0; i < response.chapter.length; i++) {
                    conceptsName.push(response.chapter[i].title)
                }
                this.setState({ conceptsInfo: response.chapter, selectedChapterTitle: response.chapter[0].chapterTitle, selectedChapterKey: response.chapter[0].chapterKey, selectedConceptsName: conceptsName, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })


            }).catch(err => {
            })
    }

    getStudents = (selectedHomework = '') => {
        let payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            verified: true,
        }

        if (this.state.payload?.section) {
            payload.section = this.state.payload?.section
        }

        if (!payload.class || !payload.board) return
        this.setState({ isLoading: true })

        if (selectedHomework) {

            


            payload.homeworkId = selectedHomework.value

            HomeworkApi.getHomeworkEvaluationReport(payload)
                .then(response => {
                    //console.log(response)
                    let { noviceStudents: noviceStudents1, proficientStudents, advancedStudents, notCompletedStudents, basePath } = response
                    this.setState({ isLoading: false, basePath: basePath, showStudentToaster: true }, () => {
                        setTimeout(() => { this.hideToaster() }, 5000);
                    })


                    let noviceStudents = [...noviceStudents1, ...notCompletedStudents]

                    //console.log({ noviceStudents, proficientStudents, advancedStudents })

                    this.adaptiveHomeworkStudents({ noviceStudents, proficientStudents, advancedStudents })
                })
                .catch(err => {
                    this.setState({ isLoading: false })
                })

        }
        else {
            SchoolUserApi.getSchoolUsers(payload)
                .then(response => {
                    //console.log(response)
                    this.setState({ isLoading: false, basePath: response.basePath })

                    if (this.props.type === 'ADAPTIVE') {
                        let noviceStudents = [], proficientStudents = [], advancedStudents = []
                        response = response?.response || []



                        for (let i = 0; i < response.length; i++) {
                            let previousYearMark = response[i]?.previousYearMark?.mark
                            if (!previousYearMark) {
                                let category = response[i].category

                                if (!category || category === "NOVICE") {
                                    noviceStudents.push(response[i])
                                } else if (category === "PROFICIENT") {
                                    proficientStudents.push(response[i])
                                } else {
                                    advancedStudents.push(response[i])
                                }

                            } else {
                                if (previousYearMark < 50) {
                                    noviceStudents.push(response[i])
                                } else if (previousYearMark >= 50 && previousYearMark <= 80) {
                                    proficientStudents.push(response[i])
                                } else {
                                    advancedStudents.push(response[i])
                                }
                            }
                        }
                        this.adaptiveHomeworkStudents({ noviceStudents, proficientStudents, advancedStudents })
                    } else {
                        this.standardHomeworkStudent(response?.response || [])
                    }

                }).catch(err => {
                    this.setState({ isLoading: false })
                })
        }

    }

    adaptiveHomeworkStudents = (response) => {
        let categories = this.state.categories

        for (let i = 0; i < categories.length; i++) {
            if (categories[i].title === 'NOVICE') {
                categories[i].students = response.noviceStudents

            } else if (categories[i].title === 'PROFICIENT') {
                categories[i].students = response.proficientStudents

            } else if (categories[i].title === 'ADVANCED') {
                categories[i].students = response.advancedStudents
            }
        }
        this.setState({ categories })
    }

    storeConceptDetails = (item) => {

        let conceptsHash = {}

        for (let i = 0; i < item.length; i++) {

            conceptsHash[item[i].conceptKey] = item[i]

        }
        this.setState({ conceptsHash: conceptsHash })
    }

    getEloDetails = (elos, index) => {

        let payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            section: this.state.payload?.section,
            chapter: this.state.payload?.chapter,
            concepts: this.state.payload.concepts ? this.state.payload.concepts : [],
            elos: elos || (this.state.payload.elos ? this.state.payload.elos : [])
        }

        if (!payload.class || !payload.board || !payload.chapter) return

        HomeworkApi.getHomeworkEloDetails(payload)
            .then(response => {
                if (this.state.isAdaptive && elos?.length) {
                    let categories = this.state.categories
                    categories[index].questionCount = response.questionCount
                    // categories[index].approximateTime = response.questionCount
                    categories[index].approximateTime = response.approximateTime

                    this.setState({
                        categories,
                        contents: response.content,
                        isLoading: false
                    })
                } else {

                    this.setState({
                        questionCount: response.questionCount,
                        contents: response.content,
                        // approximateTime: response.questionCount, //ask by ravi
                        approximateTime : response.approximateTime,
                        isLoading: false
                    })
                }

            }).catch(err => {
            })
    }


    hideToaster() {
        this.setState({
            showStudentToaster: false
        });
    }


    getStandardHomeworkList() {
        // Chapter Based Standard Homework listing as per Ravi 
        let payload = {
            board: this.state.payload?.board,
            class: this.state.payload?.class,
            section: this.state.payload?.section,
            sectionId: this.state.payload?.sectionId,
            chapter: this.state.payload?.chapter,
            //concepts: this.state.payload?.concepts,
            allHomeworkList: "ALL_HOMEWORK_LIST"
        }



        if (!payload.board || !payload.class) return;

        if (!payload.chapter) return
        HomeworkApi.getHomework(payload)
            .then(response => {
                console.log(response)
                let responseData = response.response
                //let homeworksList = [{title : "Chapter 1", value : 1}, {title : "Chapter 2", value : 2}, {title : "Chapter 3", value : 3}]


                this.buildHomeworkList(responseData)




            })
            .catch(err => {
                this.setState({ homeworkDropdownItems: [] })
                this.reloadDropdown()
            })



    }


    buildHomeworkList(homeworks) {
        let homeworkGroup = {}, individualHomework = []
        let homeworkList = []
        let allHomeworkList = []
        let allHomeworkListHash = {}
        for (let i = 0; i < homeworks.length; i++) {
            let homework = homeworks[i]
            let obj = {
                _id: homework._id,
                createdDateTimestamp: homework.countingwellCreatedTimestamp || homework.createdDate,
                createdDate: new Date(homework.countingwellCreatedTimestamp || homework.createdDate).toLocaleDateString("en-IN"),
                dueDate: new Date(homework.endDate).toLocaleDateString("en-IN"),
                chapter: homework?.chapter?.title,
                concepts: homework?.chapter?.concept,
                section: homework.section,
                class: homework.class,
                board: homework.board,
                completed: homework.completed,
                notCompleted: homework.notCompleted,
                status: homework.status,
                conceptBuild: homework?.chapter?.conceptBuild,
                notificationCount: homework?.notificationCount || 0,
                lastNotificationSentDate: homework?.lastNotificationSentDate,
                approximateQuestions: homework?.approximateQuestions,
                approximateTime: homework?.approximateTime,
                category: homework?.category,
                users: homework?.users || []
            }

            if (homework.groupId) {
                if (homeworkGroup[homework.groupId]) {
                    homeworkGroup[homework.groupId].push(obj)
                } else {
                    homeworkGroup[homework.groupId] = [obj]
                }
            } else {
                individualHomework.push(obj)
                allHomeworkListHash[homework._id.toString()] = obj
            }


            allHomeworkList.push({

                title: `Homework Created on ${CommonUtils.datePipe(homework.createdDate, false)}`,
                chapterTitle: homework.chapter.title,
                value: homework._id.toString(),
            })


        }

        let groupedHomework = Object.values(homeworkGroup)
        //console.log(allHomeworkListHash)

        homeworkList.push(...groupedHomework, ...individualHomework)

        this.setState({ homeworkList, homeworkDropdownItems: allHomeworkList, allHomeworkListHash, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })

    }




    resetErrorMessages = () => {
        this.setState({ selectBoardMessage: false, selectChapterMessage: false, selectClassMessage: false, selectConceptMessage: false, selectSectionMessage: false, selectDueDateMessage: false, selectStreamingLogic: false })
    }

    standardHomeworkStudent(studentList = []) {
        let list = []

        console.log(studentList)

        for (let i = 0; i < studentList.length; i += 3) {
            let students = studentList.slice(i, i + 3)
            list.push(students)
        }

        if (!list.length) {
            this.setState({ studentList: list, noStudentsFound: true, studentListLength : studentList.length })
        } else {
            this.setState({ studentList: list, noStudentsFound: false, studentListLength : studentList.length })
        }
    }

    handleEloDropdown = (eloDropdownItems, skillDropdownItems, conceptList) => {

        this.setState({ eloDropdownItems, skillDropdownItems, conceptList, conceptsArray: conceptList, reloadDropdown: true }, () => {

            if (eloDropdownItems?.length) {

                let noviceElo = [], proficientElo = [], advancedElo = [], noviceSelectedSkill = "", proficientSelectedSkill = "", advancedSelectedSkill = ""
                eloDropdownItems.forEach(element => {
                    if (element.skill == "Knowledge") {
                        noviceElo.push(element)
                    } else if (element.skill == "Calculation") {
                        proficientElo.push(element)
                    } else {
                        advancedElo.push(element)
                    }

                })


                if (noviceElo.length) {
                    this.onSelectElo(noviceElo, 0, ["Knowledge"])
                }

                setTimeout(() => {
                    if (proficientElo.length) {
                        this.onSelectElo(proficientElo, 1, ["Calculation"])
                    } else {
                        this.onSelectElo(noviceElo, 1, ["Knowledge"])
                    }
                }, 300)



                setTimeout(() => {
                    if (advancedElo.length) {
                        this.onSelectElo(advancedElo, 2, ["Modelling", "Comprehension"])
                    } else {
                        this.onSelectElo(noviceElo, 2, ["Knowledge"])
                    }
                }, 600)

                setTimeout(() => {
                    this.setState({ reloadDropdown: true }, () => {
                        this.setState({ reloadDropdown: false })
                    })
                }, 1000)

            } else {

                let categories = this.state.categories

                categories.forEach(element => element.selectedElo = [])

                this.setState({ categories, reloadDropdown: false })
            }

        })
    }

    showHomeworkSelectionDropdown = () => {

        let checked = this.state.selectedHomeworkBasedStudentGrouping

        this.setState({ selectedHomeworkBasedStudentGrouping: !checked }, () => {
            //console.log(checked)
            if (checked == true) {
                this.getStudents()
            }
        })

        if (checked == false) {
            this.setState({ showToaster: true })
        }




    }


    hideMoreInfoModal = () => {
        this.setState({ showMoreInfo: false })
    }

    showHomeworkInfo = (item) => {
        // let homeworkList = this.state.homeworkList
        // homeworkList[index].expand = !homeworkList[index].expand

        let homework = this.state.allHomeworkListHash[item.value]


        this.setState({ showMoreInfo: true, selectedHomeworkMore: homework })
        console.log(homework)
    }



    renderStudentCard = (student, category, index, draggable) => {
        return (

            <div className={`cw-card student ${draggable ? "drag-hand px-4 pb-4" : "p-4"}`}
                onDragStart={(e) => this.onDragStart(e, { student, category, index })}
                onDragEnd={(e) => this.onDragEnd(e)}
                draggable={draggable}>
                {/* <>{
                    this.dragStartInfo?.category?.type === category?.type && this.state.dragStartIndex === index && draggable ?
                        <div className="drag-loading">
                            <img className='' src={getImageSource(ImageConstants.DRAG_LOADING)} />
                        </div>
                        : ""}
                </> */}
                {draggable && <div className="drag-icon"> <img className='cursor-pointer' src={getImageSource(ImageConstants.DRAG)} /></div>}

                <div className=" flex">
                    <div className="profile-avatar text-center mr-2 d-inline-block">
                        <div className="row justify-content-center">
                            {/* <img className="" alt="img" src={student?.image} /> */}
                            {student.image ? <img className="" alt="img" src={`${this.state.basePath}${student.image}`} />
                                :
                                <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                        </div>
                    </div>
                    <div className="pl-2 d-inline-block">
                        <div className="student-name">{student?.name}</div>
                        <div className="student-roll-number text-left">Roll no - {student?.rollNumber}</div>
                    </div>
                </div>
            </div>
        )
    }

    renderStandard = () => {
        return (
            <div id="table-scoll" className="table-responsive mt-8">
                <table className="table cw-table mb-0 align-items-center">
                    <thead>
                        <tr>
                            <th colSpan="3" className='th-left-radius th-right-radius homework-text'>All Students {`${this.state.studentListLength ? `(${this.state.studentListLength})` : ''}`}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {/* {
                            this.state.payload?.chapter?.length ?
                                <tr key={"1-row"} className="">

                                    <td className="table-row-1 mt-4 p-4"><span>Number of Questions</span> <b className="pl-3"> {this.state.questionCount || 0}</b></td>
                                    <td className="table-row-1  p-4"><span>Approximate Time</span> <b className="pl-3">{this.state.approximateTime || 0} </b>mins</td>
                                    <td>
                                        <div className="text-right">
                                            <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.HAMBARGUR)} onClick={() => this.onClickQuestionList()} />
                                        </div>
                                    </td>
                                </tr>
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>Please select a Concept</td></tr>
                        } */}
                        {
                            this.state.studentList?.length ? this.state.studentList?.map(students => (
                                <tr key={Math.random()} className="">
                                    {
                                        students?.map((item, index) => (
                                            <td className="text-center p-4">{this.renderStudentCard(item)}</td>
                                        ))
                                    }
                                </tr>
                            ))
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                        }
                    </tbody>
                </table>
            </div >
        )
    }

    renderAdaptiveCard(cardInfo, index) {
        return (
            <div className="homework-card" onDragOver={(e) => this.onDragOver(e, cardInfo)}>

                <div className={`homework-card-header py-4 px-4 ${cardInfo.colorClass} `}>
                    <div className='container-1'>
                        <span>
                            {cardInfo.title} |
                            {
                                cardInfo.minPercentage && cardInfo.maxPercentage ?
                                    ` ${cardInfo.minPercentage} % - ${cardInfo.maxPercentage} %` :
                                    cardInfo.minPercentage && !cardInfo.maxPercentage ?
                                        ` > ${cardInfo.minPercentage} %` :
                                        ` < ${cardInfo.maxPercentage} %`
                            }
                        </span>

                        {this.state.categories[index].selectedElo ? <span className={`text-right image-ml-${index}`}>
                            <img className='report-icon cursor-pointer report-icon-nill-margin' src={getImageSource(ImageConstants.HAMBARGUR2)} onClick={() => this.onClickQuestionList(this.state.categories, index)} />
                        </span> : ""}



                    </div>

                </div>


                <div className="mt-2 bg-white p-4">
                    <div className="criterion">
                        Learning Outcomes
                    </div>
                    <div className={`cw-card mt-2 ${this.state.selectEloMessage && !cardInfo.selectedElo?.length ? "invalid" : ""}`}>
                        {
                            !this.state.reloadDropdown ?
                                <DropdownV5
                                    key="learning"
                                    placeholder='Select learning outcomes'
                                    options={this.state.eloDropdownItems}
                                    onSelect={(option) => this.onSelectElo(option, index, cardInfo.selectedFilter)}
                                    value={cardInfo.selectedElo}
                                    text={"title"}
                                    multiSelect
                                    isFilter
                                    filterKey="skill"
                                    filterItem={this.state.skillDropdownItems}
                                    filterTitle="SKILL FILTERS"
                                    isLocalSearch
                                    selectedFilter={cardInfo.selectedFilter}
                                    skillWiseSelectedOptionsCountHash={cardInfo.skillWiseSelectedOptionsCountHash}
                                />
                                :
                                ""
                        }
                    </div>
                </div>

                <div className="student-list bg-white mt-2 p-4">
                    <div className="list-background p-4">
                        {
                            cardInfo.students?.length ? cardInfo.students.map((student, index) => (
                                <div className="py-2"> {
                                    this.renderStudentCard(student, cardInfo, index, this.state.isAdaptive)}
                                </div>
                            )) : <div className="text-center" style={{ 'min-width': '400px' }}>No records found </div>}
                    </div>
                </div>
            </div>
        )
    }

    renderAdaptive = () => {
        return (

            <div className="adaptive-homework">
                {
                    this.state.categories?.length && this.state?.payload?.board && this.state?.payload?.class ? this.state.categories.map((category, index) => (
                        <div className="pr-2">
                            {this.renderAdaptiveCard(category, index)}
                        </div>
                    ))
                        : ""
                }
            </div>


        )
    }

    renderStudentGroupingByStandardHomework = () => {
        return (
            <div className='mt-3'>


                <div className='row ml-2 group-background'>


                    <div className="col-8 p-4 cursor-pointer" onClick={this.showHomeworkSelectionDropdown}>
                        {
                            this.state.selectedHomeworkBasedStudentGrouping ?
                                <div className='d-inline-block'>
                                    <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT_TICK)} />
                                </div>
                                :
                                <div className='d-inline-block'>
                                    <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT_BLACK1)} />
                                </div>
                        }
                        <span className='ml-3 mt-2'>Change the grouping of students below based on previous homework performance.</span>
                    </div>

                    {
                        this.state.selectedHomeworkBasedStudentGrouping ?
                            <div className='col-lg-3 col-md-6 col-sm-12 p-3 homework-input-margin-left'>
                                {!this.state.reloadDropdown ?
                                    <DropdownV4
                                        placeholder='Select Homework'
                                        options={this.state.homeworkDropdownItems}
                                        onSelect={(option) => this.getStudents(option)}
                                        text={"title"}
                                        showRadio
                                        showInfo
                                        showInfoModal={(option) => this.showHomeworkInfo(option)}
                                    // value={this.state.selectedChapter}
                                    /> : ''}

                            </div>
                            :
                            this.state.showToaster ? <div className='custom-toaster-modal'><ToasterComponent message="Default grouping for students is restored." type="info" position="bottom-center" ></ToasterComponent></div> : ''
                    }
                </div>
            </div>
        )
    }


    showEloDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideMoreInfoModal} size={'lg'}>
                <ModalBody >
                    <EloDetail back={this.hideMoreInfoModal} showHomeworkCreatedDate={true} item={this.state.selectedHomeworkMore} />
                </ModalBody>
            </Modal>
        )

    }



    render() {
        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='new-home-work'>

                    <div>
                        <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>

                    <div className="row pt-4" >
                        <div className="col screen-title">{this.props?.title || "New Homework"}</div>
                        {/* <div className="col">
                            {this.state.payload?.concepts?.length ?
                                <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickCreate()}>
                                    Create Homework
                                </button>
                                :
                                <></>}
                        </div> */}
                    </div>

                    <div className='row' style={{ position: "relative" }}>
                        <div className="col-11">
                            <Filter
                                type={this.props.type}
                                onGo={this.handleFilter}
                                delegate={this}
                                isCreate={this.state.isCreate}
                                isAdaptive={this.state.isAdaptive}
                                selectChapterMessage={this.state.selectChapterMessage}
                                selectBoardMessage={this.state.selectBoardMessage}
                                selectClassMessage={this.state.selectClassMessage}
                                selectSectionMessage={this.state.selectSectionMessage}
                                selectConceptMessage={this.state.selectConceptMessage}
                                selectDueDateMessage={this.state.selectDueDateMessage}
                                selectStreamingLogic={this.state.selectStreamingLogic} />
                            <div className={`create-homework-absolute ${this.state.isAdaptive ? 'create-homework-absolute-adaptive' : ''}`}>
                                {this.state.payload?.concepts?.length ?
                                    <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickCreate()}>
                                        Create Homework
                                    </button>
                                    :
                                    <></>}
                            </div>


                        </div>

                        <div className="col-1 info-position">
                            <div className="text-center">
                                <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.INFO1)} onClick={this.onClickInfo} />
                            </div>
                        </div>
                    </div>

                    {!this.state.isAdaptive ?
                        this.state.payload?.chapter?.length ?
                            <div key={"1-row"} className="bg-white qs-margin-top p-2">

                                <span className="table-row-1 p-2 ml-3"><span><span>Number of Questions</span> <b className="pl-2"> {this.state.questionCount || 0}</b></span></span>
                                <span className="table-row-1  p-2 ml-5"><span><span>Approximate Time</span> <b className="pl-2">{this.state.approximateTime || 0} </b>mins</span></span>
                                <span className='' align='right'>
                                    <span className="qs-image-float">
                                        <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.HAMBARGUR1)} onClick={() => this.onClickQuestionList()} />
                                    </span>
                                </span>
                            </div>
                            : <div className="bg-white p-2 qs-margin-top"><div colSpan="5" align='center'><span>Please select a Concept</span></div></div>

                        : ''}

                    {
                        this.state.isAdaptive && this.state.homeworkDropdownItems.length > 0 ? this.renderStudentGroupingByStandardHomework() : ''
                    }



                    <div className="mt-3">
                        {this.state.isAdaptive ? this.renderAdaptive() : this.renderStandard()}
                    </div>
                    {
                        this.state.showInfoModal ? this.showConceptDetail() : ""
                    }
                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }
                    {
                        this.state.showMoreInfo ? this.showEloDetail() : ""
                    }
                    {
                        this.state.showStudentToaster ? <div className='custom-toaster-modal'><ToasterComponent message="Students are now grouped as per their last homework performance." type="info" position="bottom-center" ></ToasterComponent></div> : ''

                    }
                </div>
            </>);
    }
}

export default NewHomeWork;